export default function PricingBanner() {
  return (
    <>
      <section className="relative w-full min-h-[260px] sm:min-h-[280px] md:h-[320px] flex items-end sm:items-center justify-center overflow-hidden pt-20 pb-10 sm:py-12 md:py-0">
        <div
          className="absolute inset-0 bg-cover bg-no-repeat bg-[position:50%_20%] md:bg-[position:center_20%]"
          style={{
            backgroundImage: `url('https://storage.readdy-site.link/project_files/0e36dce5-70eb-43ef-8fa1-9c06248cd1a7/43162f55-c182-45af-b8f5-6677d16cb206_Gemini_Generated_Image_otz3msotz3msotz3.pngv=a1b1d2c8afaa20ef952fdcb841ce2f36')`,
          }}
        />
        <div className="absolute inset-0" style={{ background: 'rgba(10,5,30,0.68)' }} />
        <div className="absolute inset-0" style={{ background: 'linear-gradient(to bottom, rgba(83,74,183,0.18) 0%, rgba(10,5,30,0.30) 100%)' }} />

        <div className="relative z-10 text-center px-6 sm:px-8 md:px-6 max-w-3xl mx-auto w-full">
          <h1 className="font-title text-[1.6rem] leading-snug sm:text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-3 md:mb-4 w-full">
            Elige el plan que mejor se adapta a tu familia
          </h1>
          <p className="text-white/70 text-sm sm:text-sm md:text-base lg:text-lg font-light">
            Plan Basico desde $289 al mes. Reglas claras desde tu registro.
          </p>
        </div>
      </section>

      <div
        className="w-full py-4 px-4"
        style={{
          background: 'linear-gradient(90deg, #3C3489 0%, #534AB7 50%, #7F77DD 100%)',
        }}
      >
        <div className="max-w-4xl mx-auto flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-3 text-center sm:text-left">
          <div className="hidden sm:flex w-9 h-9 items-center justify-center rounded-full bg-white/15 flex-shrink-0">
            <i className="ri-lock-2-fill text-white text-base"></i>
          </div>
          <div>
            <p className="text-white font-semibold text-xs sm:text-sm md:text-base">
              Conserva tu tarifa de registro 2026
            </p>
            <p className="text-white/75 text-xs mt-0.5">
              Tu tarifa de registro se respeta mientras la membresia siga activa, conforme a condiciones del plan.
            </p>
          </div>
          <div className="hidden sm:block w-px h-8 bg-white/20 mx-2"></div>
          <div className="flex items-center gap-2 bg-white/15 border border-white/25 rounded-full px-4 py-1.5 flex-shrink-0">
            <i className="ri-shield-check-fill text-[#AFA9EC] text-sm"></i>
            <span className="text-white text-xs font-semibold whitespace-nowrap">Tarifa de registro</span>
          </div>
        </div>
      </div>
    </>
  );
}
